import { render, staticRenderFns } from "./AreaViewPage.vue?vue&type=template&id=2a3ada17&"
import script from "./AreaViewPage.vue?vue&type=script&lang=js&"
export * from "./AreaViewPage.vue?vue&type=script&lang=js&"
import style0 from "./AreaViewPage.vue?vue&type=style&index=0&id=2a3ada17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports